(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-circle"] && !Shopify.designMode) return;
  try {
    
  const textElement = document.querySelector('[js-animated-circle="changingWord"]');
  const texts = ['Organic', 'Vegan'];
  let currentIndex = 0;

  function changeText() {
    textElement.textContent = texts[currentIndex];
    currentIndex = (currentIndex + 1) % texts.length;
  }

  setInterval(changeText, 5000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits"] && !Shopify.designMode) return;
  try {
    
  // nodeSelectors
  const benefitToggle = [...document.querySelectorAll('[js-benefits="toggle"]')];
  
  const benefitImage = document.querySelector('[js-benefits="image"]');
  const benefitDetails = document.querySelector('[js-benefits="details"]');

  // variables
  let swiper = {};

  init();

  function init() {
    setEventListeners();
    initSwiper();
  }

  function setEventListeners() {
    benefitToggle.forEach((toggle) => {
      toggle.addEventListener("click", (event) => {
        updateButtonState(event.target);
        updateContent(event.target);
      });
    })
  }

  function initSwiper() {
    swiper = new Swiper('[js-benefits="swiper"]', {
      centeredSlides: true,
      slidesPerView: 1,
      initialSlide: 0,
      spaceBetween: 22,
      loop: true,
    });

    swiper.on('slideChange', function () {
      const activeSlide = document.querySelector('.benefits__swiper-slide.swiper-slide.swiper-slide-active');

      if (!activeSlide) {
        return;
      }

      const benefitsSection = activeSlide.closest('section.benefits');

      if (benefitsSection) {
        benefitsSection.style.backgroundColor = activeSlide.dataset?.backgroundColor
      }
    });
  }

  function updateButtonState(eventTarget) {
    benefitToggle.forEach((toggle) => {
      const benefitNameParent = toggle.closest('.benefits__benefit-item');
      
      if (!benefitNameParent) {
        return;
      }
      
      benefitNameParent.classList.remove('is-active');
    })

    const benefitNameParent = eventTarget.closest('.benefits__benefit-item');

    if (!benefitNameParent) {
      return;
    }
    
    benefitNameParent.classList.add('is-active');
  }

  function updateContent(button) {
    if (benefitImage) {
      benefitImage.alt = button.dataset.name
      benefitImage.src = button.dataset.image
    }

    if (benefitDetails) {
      benefitDetails.innerHTML = button.dataset.details
    }

    const benefitsSection = button.closest('section.benefits');

    if (benefitsSection) {
      benefitsSection.style.backgroundColor = button.dataset?.backgroundColor
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-icon-text"] && !Shopify.designMode) return;
  try {
    
  const iconTextCarouselSwiper = [...document.querySelectorAll('[js-carousel-icon-text="swiper"]')];

  let iconTextCarousel = {};

  iconTextCarouselSwiper.forEach((carousel) => {
    iconTextCarousel = new Swiper(carousel, {
      slidesPerView: 1,
      loop: true,
      speed: 600,
      spaceBetween: 24,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        767: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        }
      }
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-testimonials"] && !Shopify.designMode) return;
  try {
    
  // nodeSelectors
  const section = document.querySelector('[js-community-testimonials="section"]');
  const swiperSlideNumber = document.querySelector('[js-community-testimonials="swiperSlideNumber"]');

  // variables
  let swiper = {};
  let blocksLength = 0;

  if (section) {
    blocksLength = Number(section.dataset?.blocksLength)
  }

  init();

  function init() {
    initSwiper();
  }

  function initSwiper() {
    swiper = new Swiper('[js-community-testimonials="swiper"]', {
     effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      autoHeight: true,
      initialSlide: (blocksLength / 2),
      slidesPerView: 1.2,
      breakpoints: {
        1024: {
          slidesPerView: 2.5,
        },
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 300,
        modifier: 1,
        slideShadows: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    swiper.on('slideChange', function () {
      if (!swiperSlideNumber) {
        return;
      }

      swiperSlideNumber.innerText = `${swiper.realIndex + 1} / ${blocksLength}`
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  const popup = document.querySelector('[js-newsletter-popup="popup"]');
  const closeButton = document.querySelector('[js-newsletter-popup="close"]');
  const backgroundOverlay = document.querySelector('[js-newsletter-popup="backgroundOverlay"]');

  let delay = 0;

  if (popup) {
    delay = Number(popup.dataset.delay);
  }

  init();

  function init() {
    setEventListeners();

    const sessionStorageState = sessionStorage.getItem('newsletter_popup');

    if (sessionStorageState !== 'dismissed') {
      window.setTimeout(() => {
        showPopup();
      }, delay);
    }
  }

  function setEventListeners() {
    if (closeButton) {
      closeButton.addEventListener("click", closePopup);
    }
  
    if (backgroundOverlay) {
      backgroundOverlay.addEventListener("click", closePopup);
    }
  }

  function showPopup() {
    if (!popup) {
      return;
    }

    popup.classList.remove('hidden');

    handleBackgroundOverlay('SHOW');
  }

  function closePopup() {
    if (!popup) {
      return;
    }

    popup.classList.add('hidden');

    handleBackgroundOverlay('CLOSE');

    setSessionStorageClose();
  }

  function handleBackgroundOverlay(visibility) {
    if (!backgroundOverlay) {
      return;
    }

    const body = document.body
    const themeWrapper = body.querySelector('[js-theme="wrapper"]')

    if (visibility === 'CLOSE') {
      backgroundOverlay.classList.add('hidden');

      // Enable body scroll
      body.style.overflowY = 'initial';

      if (themeWrapper) {
        themeWrapper.style.maxHeight = 'initial';
        themeWrapper.style.overflowY = 'initial';
      }
      
      return;
    } 

    backgroundOverlay.classList.remove('hidden');

    // Disable body scroll
    body.style.overflowY = 'scroll';

    if (themeWrapper) {
      themeWrapper.style.maxHeight = '100vh';
      themeWrapper.style.overflowY = 'hidden';
    }
  }

  function setSessionStorageClose() {
    window.sessionStorage.setItem('newsletter_popup', 'dismissed');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-inside"] && !Shopify.designMode) return;
  try {
    
  const whatsInsideSwiper = document.querySelector('[js-whats-inside="swiper"]');

  let swiper = {};
  
  if (whatsInsideSwiper) {
    swiper = new Swiper(whatsInsideSwiper, {
      autoHeight: true,
      spaceBetween: 12,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  swiper.on('slideChange', function () {
    const whatsInsideSlideCount = document.querySelector('[js-whats-inside="slideCount"]');

    if (whatsInsideSlideCount) {
      whatsInsideSlideCount.innerText = swiper.realIndex + 1;
    }
  });

  const toggleButtons = document.querySelectorAll('[js-whats-inside="toggle"]');

  toggleButtons.forEach((toggle) => {
    toggle.onclick = function () {
      this.classList.toggle("is-open");

      if (this.parentElement.classList.contains("swsl")) {
        // Remove the "swsl" class from the parent element
        this.parentElement.classList.remove("swsl");
    }
      
      let content = this.nextElementSibling;

      content.classList.toggle("is-open");

      const toggleIcon = toggle.querySelector('[js-whats-inside="toggleIcon"]');

      swiper.updateSize()

      if (!content.classList.contains('is-open')) {
        content.style.maxHeight = null;

        if (toggleIcon) {
          toggleIcon.src = "https://cdn.shopify.com/s/files/1/0742/3659/2438/files/icon-plus.png?v=1694116876"
        }
      } else {
        content.style.maxHeight = content.scrollHeight + 10 + "px";

        if (toggleIcon) {
          toggleIcon.src = "https://cdn.shopify.com/s/files/1/0742/3659/2438/files/icon-minus.png?v=1694116876"
        }
      }
    };
  });

  } catch(e) { console.error(e); }
})();
})();
